import { useCallback, useRef, useState } from 'react';

import { useHistory } from 'react-router-dom';

import {
  DashboardV2EventProps,
  DashboardV2Events,
} from '~/analytics/dashboardV2Events';
import { ALERT_STATUS } from '~/lib/constants/providerDashboard.constants';
import { useAnalytics } from '~/lib/contexts/AnalyticsContext';
import { useProviderSupervisor } from '~/lib/contexts/ProviderSupervisorContext';
import { ProviderAlert } from '~/lib/types/providerDashboard';
import { Path } from '~/routes/constants';
import { useUpdateAlertStatusMutation } from '~/store/services/providerDashboardV2';

import { isUnreadAlert } from './alerts.util';

export const useReviewAlert = () => {
  const history = useHistory();
  const { viewingProviderId } = useProviderSupervisor();
  const { trackEvent } = useAnalytics() ?? {};
  const [updateAlertStatus] = useUpdateAlertStatusMutation();
  const [reviewingAlertId, setReviewingAlertId] = useState<string | null>(
    null,
  );
  const isReviewInFlight = useRef(false);

  const reviewAlert = useCallback(
    (alert: ProviderAlert) => {
      if (isReviewInFlight.current) return;
      isReviewInFlight.current = true;
      setReviewingAlertId(alert.alertId);
      trackEvent?.(DashboardV2Events.alertReviewed, {
        [DashboardV2EventProps.SignalType]: alert.alertType,
      });

      if (isUnreadAlert(alert)) {
        updateAlertStatus({
          providerId: viewingProviderId,
          alertId: alert.alertId,
          status: ALERT_STATUS.ACKNOWLEDGED,
          patientExternalId: alert.patientExternalId,
        });
      }

      isReviewInFlight.current = false;
      setReviewingAlertId(null);
      history.push(`${Path.MAUD_PATIENTS}/${alert.patientExternalId}`);
    },
    [history, trackEvent, updateAlertStatus, viewingProviderId],
  );

  return { reviewAlert, reviewingAlertId };
};
